import { render, staticRenderFns } from "./Personalisation.vue?vue&type=template&id=6650c5b4"
import script from "./Personalisation.vue?vue&type=script&lang=ts"
export * from "./Personalisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports